import {
    DeviceTypeTriggerCatalogue,
    TrackedTrigger,
} from 'modules/settings/pods/settings-operator-custom-notifications/operator-custom-notification.vm';
import { toTrackedTrigger } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/settings-operator-custom-notification-form.mapper';
import {
    fromTriggerOptionId,
    toTriggerOptionId,
} from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notification-form/operator-trigger-id.business';

// The option id carries no display name, which the write contract needs, so the
// selection is resolved against the loaded catalogue.
export const hydrateTriggerSelection = (
    triggerOptionIds: string[],
    catalogue: DeviceTypeTriggerCatalogue[]
): TrackedTrigger[] =>
    triggerOptionIds
        .map((optionId) => {
            const pair = fromTriggerOptionId(optionId);

            if (!pair) {
                return undefined;
            }

            const trigger = catalogue
                .find((entry) => entry.deviceTypeId === pair.deviceTypeId)
                ?.triggers.find((candidate) => candidate.id === pair.id);

            return trigger && toTrackedTrigger(trigger);
        })
        .filter((trigger): trigger is TrackedTrigger => trigger !== undefined);

export const getUnresolvedTriggerIds = (
    triggerOptionIds: string[],
    catalogue: DeviceTypeTriggerCatalogue[]
): string[] => {
    const resolvedIds = new Set(
        hydrateTriggerSelection(triggerOptionIds, catalogue).map((trigger) =>
            toTriggerOptionId(trigger.deviceTypeId, trigger.id)
        )
    );

    return triggerOptionIds.filter((optionId) => !resolvedIds.has(optionId));
};

export const hasUnavailableTriggerSelection = (unresolvedTriggerIds: string[], isCatalogueSettled: boolean): boolean =>
    isCatalogueSettled && unresolvedTriggerIds.length > 0;
